import { SET_IDEAS, SET_THREADS, DISPLAY_POCKET_IDEA } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').PocketIdeasState} PocketIdeasState
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {PocketIdeasState}
 */
const INITIAL_STATE = {
  ideas: [],
  threads: [],
  ideaToDisplay: null,
}

/**
 * @param {PocketIdeasState} state
 * @param {PltrAction} action
 * @return {PocketIdeasState}
 */
export default function ideasReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_IDEAS: {
      return {
        ...state,
        ideas: action.ideas,
      }
    }
    case SET_THREADS: {
      return {
        ...state,
        threads: action.threads,
      }
    }
    case DISPLAY_POCKET_IDEA: {
      return {
        ...state,
        ideaToDisplay: action.pocketIdeaId,
      }
    }
    default: {
      return state
    }
  }
}
